export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-960-ad1c0918c3a6224c5c7bbced1bc694cb.png";